export default __webpack_public_path__ + "static/media/uniqueid.dd5638cd.svg";